const toLocale = (val: string, lang: string): string => {
  const langCode = lang === 'ja' ? 'ja-JP' : 'en-US'
  return Number(val).toLocaleString(langCode)
}

export default toLocale
